module.exports = __webpack_public_path__ + "img/renyuan.8dfaeeac.png";